import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class{
    constructor(){
        this.run(document);
    }
    run(d){
        const lineAnimations = d.querySelectorAll('[data-text-animation]');
        if (lineAnimations.length > 0) {
            lineAnimations.forEach((el) => {
                const inner = document.createElement('div');
                inner.setAttribute('data-text-animation-inner', '');
                inner.innerHTML = el.innerHTML;
                el.innerHTML = '';
                el.appendChild(inner);
            });
        }

        const textAnimation = document.querySelectorAll("[data-text-animation-trigger]");
        textAnimation.forEach(el => {
            const target = el.querySelectorAll("[data-text-animation-inner]");
            gsap.fromTo(
                target,
                {
                    y: "105%"
                },
                {
                    y: "0%",
                    duration: 1.5,
                    ease: "power2.out",
                    stagger: 0.15,
                    scrollTrigger: {
                        trigger: el,
                        start: "top 70%",
                        // markers: true,
                    }
                }
            );
        });
    }
}